import { ConnectionDetail } from '~src/ts/ServerApi/types/ConnectionDetail';

import { filePathDisplayStringWithBaseNameFirst } from '../../common/utilities/FilePathUtils';
import { IDataConnectionInfo } from '../../ts/models/IDataConnectionInfo';
import { IDataConnection } from '../../ts/ServerApi/types/IDataConnection';

export type ConnectionCategory = 'external' | 'file' | 'tableau' | 'tableausite' | 'unknown';

export function connectionDetailsTypeToConnectionCategory(type: ConnectionDetail['type']) {
  switch (type) {
    case 'database':
    case 'webdata-direct':
      return 'external';
    case 'file':
      return 'file';
    case 'tableauserver':
      return 'tableau';
    case 'tableauserversite':
      return 'tableausite';
    default:
      return 'unknown';
  }
}

export function getConnectionCategory(connection: IDataConnection | IDataConnectionInfo | null): ConnectionCategory {
  if (!connection) {
    return 'unknown';
  }
  const details = connection.connectionDetails;
  return connectionDetailsTypeToConnectionCategory(details.type);
}

export function getOutputStepIconFromConnectionCategory(connectionCategory: ConnectionCategory): string {
  switch (connectionCategory) {
    case 'external':
      return 'tb-icon-datasource-connection-external';
    case 'file':
      return 'tb-icon-datasource-connection-file';
    case 'tableau':
      return 'tb-icon-datasource-connection-tableau';
    case 'tableausite':
      return 'tb-icon-datasource-connection-tableau';
    default:
      return '';
  }
}

export function getConnectionText(connection: IDataConnection | IDataConnectionInfo | null): string {
  if (!connection) {
    return '';
  }
  const details = connection.connectionDetails;
  switch (details.type) {
    case 'database':
    case 'webdata-direct':
      return details.serverName;
    case 'file':
      return filePathDisplayStringWithBaseNameFirst(details.fileName);
    case 'tableauserver':
      return details.name;
    case 'tableauserversite':
      return details.siteUrl;
    default:
      return '';
  }
}
